import Icon from "./Icon";
import React from "react";

const Chip = React.forwardRef(({
  pure,
  filter,
  assist,
  input,
  disabled,
  small,
  error,
  selected,
  className,
  onClick,
  style,
  iconProps,
  symbol,
  inputSymbol,
  children,
  ...rest
}, ref) => {
  const derivedVariant = filter
    ? "filter"
    : assist
      ? "assist"
      : input
        ? "input"
        : undefined;

  const classes = [!pure && "ta-chip", className].filter(Boolean).join(" ");

  const action = (e) => {
    onClick({
      clientWidth: e.currentTarget.clientWidth,
      clientHeight: e.currentTarget.clientHeight,
      offsetLeft: e.currentTarget.offsetLeft,
      offsetTop: e.currentTarget.offsetTop,
      clientX: e.nativeEvent.clientX,
      clientY: e.nativeEvent.clientY,
      offsetX: e.nativeEvent.offsetX,
      offsetY: e.nativeEvent.offsetY,
    });
  };

  return (
    <button
      ref={ref}
      onClick={onClick && action}
      className={classes}
      style={style}
      disabled={disabled}
      data-variant={derivedVariant}
      data-selected={selected || undefined}
      data-error={error || undefined}
      data-size={small ? "s" : undefined}
      {...rest}
    >
      <>
        {selected && filter ? (
          <Icon symbol="check" {...iconProps} className="ta-chip_icon" />
        ) : (
          symbol && (
            <Icon
              symbol={symbol}
              {...iconProps}
              className="ta-chip_icon"
            />
          )
        )}
        {children && (
          <label className="ta-chip_label">{children}</label>
        )}
        {input && (
          <Icon
            symbol={inputSymbol ? inputSymbol : "close"}
            className="ta-chip_input"
          />
        )}
      </>
    </button>
  );
});

export default Chip;
